var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "scale-in-center" } }, [
    _c("div", { attrs: { id: "order-service-page" } }, [
      _vm.app_env == "local" || _vm.app_env == "development"
        ? _c("span", { staticClass: "development-label" }, [
            _vm._v("\n            Testovací prostředí\n        "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "close-block" }, [
        _c(
          "a",
          {
            staticClass: "close-block-button",
            on: {
              click: function ($event) {
                return _vm.closeModal()
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "aria-hidden": "true",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid-container" },
        [
          _c("div", { staticClass: "grid-x grid-padding-x" }, [
            _c(
              "div",
              { staticClass: "large-8 medium-9 small-12 cell centered" },
              [
                _vm.serviceLoadStatus == 2
                  ? _c("h2", { staticClass: "page-title" }, [
                      _vm._v(_vm._s(_vm.$t("order.titleInspector"))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.serviceLoadStatus == 2
                  ? _c("span", { staticClass: "service-title" }, [
                      _vm._v(_vm._s(_vm.serviceName)),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("loader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.serviceLoadStatus == 0 || _vm.serviceLoadStatus == 1,
                expression: "serviceLoadStatus == 0 || serviceLoadStatus == 1",
              },
            ],
            attrs: { width: 100, height: 100 },
          }),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label" }, [
                            _vm._v(_vm._s(_vm.$t("order.licensePlate"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.license,
                                expression: "license",
                              },
                            ],
                            staticClass: "form-input",
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: _vm.license },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.license = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.mileage"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.mileage,
                                expression: "mileage",
                              },
                            ],
                            ref: "mileage",
                            staticClass: "form-input",
                            class: {
                              invalid: !_vm.validations.mileage.is_valid,
                            },
                            attrs: { type: "text", maxlength: "7" },
                            domProps: { value: _vm.mileage },
                            on: {
                              keypress: _vm.validNumber,
                              paste: function ($event) {
                                $event.preventDefault()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.mileage = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.mileage.is_valid,
                                  expression: "!validations.mileage.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.mileage.text))]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("h5", { staticClass: "section-title" }, [
                      _vm._v(_vm._s(_vm.$t("order.contactSectionLabel"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.firstName"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.firstName,
                                expression: "firstName",
                              },
                            ],
                            ref: "firstName",
                            staticClass: "form-input",
                            class: {
                              invalid: !_vm.validations.firstName.is_valid,
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.firstName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.firstName = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.firstName.is_valid,
                                  expression: "!validations.firstName.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.firstName.text))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.lastName"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.lastName,
                                expression: "lastName",
                              },
                            ],
                            ref: "lastName",
                            staticClass: "form-input",
                            class: {
                              invalid: !_vm.validations.lastName.is_valid,
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.lastName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.lastName = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.lastName.is_valid,
                                  expression: "!validations.lastName.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.lastName.text))]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.email"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.emailAddress,
                                expression: "emailAddress",
                              },
                            ],
                            ref: "emailAddress",
                            staticClass: "form-input",
                            class: {
                              invalid: !_vm.validations.emailAddress.is_valid,
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.emailAddress },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.emailAddress = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.emailAddress.is_valid,
                                  expression:
                                    "!validations.emailAddress.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.emailAddress.text))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.phone"))),
                          ]),
                          _vm._v(" "),
                          _c("VuePhoneNumberInput", {
                            attrs: {
                              maxlength: "11",
                              color: "#c8017d",
                              "default-country-code": "CZ",
                              required: "",
                              "only-countries": _vm.phoneNumberOnlyCountries,
                              translations: _vm.phoneNumberTranslations,
                            },
                            on: { update: _vm.onUpdatePhoneNumber },
                            model: {
                              value: _vm.phoneNumber,
                              callback: function ($$v) {
                                _vm.phoneNumber = $$v
                              },
                              expression: "phoneNumber",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.phoneNumber.is_valid,
                                  expression:
                                    "!validations.phoneNumber.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.phoneNumber.text))]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2 && this.service.maintenance_slot == true
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  {
                    staticClass: "large-8 medium-9 small-12 cell centered",
                    staticStyle: { "margin-bottom": "100px" },
                  },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-12 medium-12 small-12 cell" },
                        [
                          _c("h5", { staticClass: "section-title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("order.selectionDateSectionLabel"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.selectedSlot.is_valid,
                                  expression:
                                    "!validations.selectedSlot.is_valid",
                                },
                              ],
                              staticClass: "validation",
                              staticStyle: { "text-align": "center" },
                            },
                            [_vm._v(_vm._s(_vm.validations.selectedSlot.text))]
                          ),
                          _vm._v(" "),
                          _c("loader", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.serviceSlotsLoadStatus == 1,
                                expression: "serviceSlotsLoadStatus == 1",
                              },
                            ],
                            attrs: { width: 100, height: 100 },
                          }),
                          _vm._v(" "),
                          _vm.serviceSlotsLoadStatus == 2
                            ? _c("vue-cal", {
                                ref: "vuecal",
                                attrs: {
                                  locale: _vm.$i18n.locale,
                                  "hide-view-selector": "",
                                  "active-view": "week",
                                  "disable-views": [
                                    "years",
                                    "year",
                                    "month",
                                    "day",
                                  ],
                                  time: false,
                                  events: _vm.events,
                                },
                                on: { "event-focus": _vm.onEventFocus },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function ({ title, view }) {
                                        return [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(title) +
                                              "\n                                "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "arrow-prev",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.clickedPrevCal()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("i", { staticClass: "angle" }),
                                              _vm._v(" "),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "arrow-next",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.clickedNextCal()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("i", { staticClass: "angle" }),
                                              _vm._v(" "),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "weekday-heading",
                                      fn: function ({ heading }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              heading.label.substring(0, 2)
                                            ) +
                                              " " +
                                              _vm._s(
                                                heading.date.format("DD. MM.")
                                              )
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "event",
                                      fn: function ({ event, view }) {
                                        return [
                                          _c("div", {
                                            ref: "slot-" + event.id,
                                            staticClass: "vuecal__event-title",
                                            class: "slot-" + event.id,
                                            attrs: { id: "slot-" + event.id },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                event.title +
                                                  "<span>" +
                                                  event.subtitle +
                                                  "</span>"
                                              ),
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1263793409
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-12 medium-12 small-12 cell" },
                        [
                          this.selectedEvent.id
                            ? _c(
                                "span",
                                { staticClass: "selected-slot-text" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "order.selectionDateSectionSelectedSlotFirst"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.formatDate(this.selectedEvent.start)
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "order.selectionDateSectionSelectedSlotSecond"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(_vm.serviceSlotReservationTime) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-12 medium-12 small-12 cell" },
                        [
                          _c("span", { staticClass: "bottom-security-text" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("order.securityInfoFirst")) +
                                " "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.$t("order.securityInfoLink"),
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("order.securityInfoSecond"))
                                ),
                              ]
                            ),
                            _vm._v(".\n                                "),
                            _c("br"),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("order.mandatoryInfoFirst")) +
                                " "
                            ),
                            _c("span", { staticClass: "mandatory" }, [
                              _vm._v("*"),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("order.mandatoryInfoSecond")) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-4 medium-5 small-12 cell centered" },
                  [
                    _c("loader", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.orderInspectionFormSentStatus == 1,
                          expression: "orderInspectionFormSentStatus == 1",
                        },
                      ],
                      attrs: { width: 100, height: 100 },
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.orderInspectionFormSentStatus != 1,
                            expression: "orderInspectionFormSentStatus != 1",
                          },
                        ],
                        staticClass: "order-button",
                        on: {
                          click: function ($event) {
                            return _vm.submitOrderInspector()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("order.submitFormButton")))]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }